/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Include_Program_InfoInputs */

const en_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Program Information`)
};

const fr_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure les informations sur le programme`)
};

const de_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programminformationen einbeziehen`)
};

const it_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi informazioni sul programma`)
};

const ru_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите информацию о программе.`)
};

const es_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir información del programa`)
};

const zh_cn2_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含项目信息`)
};

const ja_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラム情報を含める`)
};

const hi_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम की जानकारी शामिल करें`)
};

const pt_pt2_subtitle_export_include_program_info = /** @type {(inputs: Subtitle_Export_Include_Program_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir informações sobre o programa`)
};

/**
* | output |
* | --- |
* | "Include Program Information" |
*
* @param {Subtitle_Export_Include_Program_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_include_program_info = /** @type {((inputs?: Subtitle_Export_Include_Program_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Include_Program_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_include_program_info(inputs)
	if (locale === "de") return de_subtitle_export_include_program_info(inputs)
	if (locale === "it") return it_subtitle_export_include_program_info(inputs)
	if (locale === "ru") return ru_subtitle_export_include_program_info(inputs)
	if (locale === "es") return es_subtitle_export_include_program_info(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_include_program_info(inputs)
	if (locale === "ja") return ja_subtitle_export_include_program_info(inputs)
	if (locale === "hi") return hi_subtitle_export_include_program_info(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_include_program_info(inputs)
	return en_subtitle_export_include_program_info(inputs)
});